import { BUTTON_VARIANTS } from 'ui/button';
import { Close16 } from 'ui/icons';

import {
  Wrapper,
  InlineFormField,
  FieldHeader,
  KeyValueInput,
  DeleteButton,
} from './KeyValuePair.styled';

import type { KeyValuePair as KVP } from '../types';

const t = {
  key: {
    id: 'key',
    label: 'Name',
    errorText: 'Must have name',
  },
  value: {
    id: 'value',
    label: 'Value',
  },
};

type Props = {
  k: string;
  v: string;
  showHeader: boolean;
  hasError?: boolean;
  errorText?: string;
  keyReadOnly?: boolean;
  editable?: boolean;
  canDelete?: boolean;
  onChange: (value: KVP) => void;
  onBlurKey: () => void;
  onDelete: () => void;
};

export const KeyValuePair = ({
  k,
  v,
  showHeader = false,
  hasError = false,
  keyReadOnly = false,
  editable = true,
  canDelete = true,
  onChange,
  onDelete,
  onBlurKey,
}: Props) => {
  return (
    <Wrapper>
      {showHeader && (
        <>
          <FieldHeader>{t.key.label}</FieldHeader>
          <FieldHeader>{t.value.label}</FieldHeader>
        </>
      )}
      <InlineFormField errorText={t.key.errorText} inputId={t.key.id} hasError={hasError}>
        <KeyValueInput
          type="text"
          hasError={hasError}
          isRequired
          isDisabled={keyReadOnly}
          isReadOnly={keyReadOnly}
          onChange={(val: string) => onChange({ key: val, value: v })}
          onBlur={onBlurKey}
          value={k}
        />
      </InlineFormField>
      <InlineFormField hasError={false}>
        <KeyValueInput
          type="text"
          id="value"
          isReadOnly={!editable}
          onChange={(val: string) => onChange({ key: k, value: val })}
          value={v}
        />
      </InlineFormField>
      {editable && canDelete && (
        <DeleteButton onClick={onDelete} variant={BUTTON_VARIANTS.GHOST}>
          <Close16 />
        </DeleteButton>
      )}
    </Wrapper>
  );
};
